import React from 'react';
import Modal from './Modal';
import {themableImagePath} from "../utils/imageUtils";
import ModalFooter from "./ModalFooter";
import {getExcursionsText, getLogOutModalTitle} from "../utils/themeUtils";
import { Trans, useLingui } from '@lingui/react/macro';

function LogoutModal (props) {
    const {t} = useLingui();
    return (
        <Modal
            show={props.showModal}
            onClose={props.hideModal}
            title={getLogOutModalTitle()}
        >
            <div className="flex grow flex-col">
                <div className="grow bg-white py-4 px-2 sm:px-4">
                    <div className="bg-grey-lighter py-4 px-2 sm:px-4">
                        <div className="flex items-center text-2xl mb-4 uppercase">
                            <img alt="" className="w-6 h-6 mr-2" src={themableImagePath('infoicon_inverted.svg')} />
                            <span className="text-primary-dark">
                                <Trans id="are_you_forgetting_something">Are you forgetting something?</Trans>
                            </span>
                        </div>
                        <div className="my-2">
                            <Trans id="finish_reserving_excursions_before_leaving">You're about to leave this page, but you haven't finished reserving some of the destination {getExcursionsText()} that are in your planner.</Trans>
                        </div>
                        <div className="my-2">
                            <Trans id="excursions_in_planner_will_not_be_reserved">Any {getExcursionsText()} in your planner, will not be reserved if you do not finish the reservation process.</Trans>
                        </div>
                        <div className="my-2">
                            <Trans id="do_you_still_want_to_leave">Do you still want to leave?</Trans>
                        </div>
                    </div>
                </div>
                <ModalFooter
                    onCancel={props.hideModal}
                    actionDisabled={false}
                    actionButtonText={t({id: "continue"})}
                    onActionClick={props.logout}
                />
            </div>
        </Modal>
    )
}


export default LogoutModal;
